
export default {
  props: {
    feels: { type: Array, default: () => [] },
    scales: { type: Array, default: () => [] },
  },

  data: () => ({
    rectInitXCoords: [4.3, 61, 117.83, 175.92],
    rectDiffX: 227.59,
  }),

  computed: {
    bedXCoordsList() {
      let list = this.scales.map(
        scale =>
          this.rectInitXCoords[this.degree(scale) - 1] +
          (this.scaleInteger(scale) - 1) * this.rectDiffX +
          10
      );
      return list;
    },
  },

  methods: {
    scaleInteger(scale) {
      return Math.trunc(scale);
    },
    degree(scale) {
      return Math.trunc(Math.round((scale - Math.trunc(scale)) * 100) / 10);
    },
    isFontClassBold(feel) {
      return (
        this.scales.length === 3 || feel === this.scaleInteger(this.scales[0])
      );
    },
  },
};
